import type { AnalyticsEvent } from './types';

export const fireGtmEvent = <T extends object>(
  event: AnalyticsEvent,
  properties: T,
): void => {
  window.dataLayer ||= [];
  window.dataLayer.push({ event, ...(properties as Record<string, unknown>) });
};
